import { render, staticRenderFns } from "./storestaff.vue?vue&type=template&id=0df03b62&scoped=true"
import script from "./storestaff.vue?vue&type=script&lang=js"
export * from "./storestaff.vue?vue&type=script&lang=js"
import style0 from "./storestaff.vue?vue&type=style&index=0&id=0df03b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df03b62",
  null
  
)

export default component.exports